import { defineComponent as _defineComponent } from 'vue'
import { ref } from 'vue';
import CButton from './shared/CButton';


export default /*#__PURE__*/_defineComponent({
  __name: 'SortUpdateModal',
  props: {
    onCancel: null,
    onConfirm: null
  },
  setup(__props: any) {

const props = __props as {
    onCancel?: () => void;
    onConfirm?: () => void;
};



const isVisible = ref(true);

const onCloseHandler = () => {
    props.onCancel?.();
};

const onConfirmHandler = () => {
    props.onConfirm?.();
};

return { __sfc: true,props, isVisible, onCloseHandler, onConfirmHandler, CButton }
}

})